export const RESPONSIVE_BREAKPOINT = 991;

export const isMobileView = () => {
  return window.innerWidth < RESPONSIVE_BREAKPOINT;
};